import { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, getMe } from './api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('stockops_token');
    const savedUser = localStorage.getItem('stockops_user');
    
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
        // Verify token is still valid
        getMe().then(res => {
          setUser(res.data);
          localStorage.setItem('stockops_user', JSON.stringify(res.data));
        }).catch(() => {
          logout();
        });
      } catch {
        logout();
      }
    }
    setLoading(false);
  }, []);

  const login = async (accessCode) => {
    const response = await apiLogin(accessCode);
    const { token, user: userData } = response.data;
    localStorage.setItem('stockops_token', token);
    localStorage.setItem('stockops_user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('stockops_token');
    localStorage.removeItem('stockops_user');
    setUser(null);
  };

  const isAdmin = () => user?.role === 'admin';

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
